import React, {useState} from "react";
import {Map, TileLayer , Marker} from "react-leaflet";
import "react-leaflet-fullscreen-control";
import Search from "react-leaflet-search";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./index.css";

function _Map() {
    const [selectedPosition, setSelectedPosition] = useState([35.693633, 51.410469]);
    const [initialPosition, setInitialPosition] = useState([35.693633, 51.410469]);
    const [zoom, setZoom] = useState(10);

    const Markers = () => {
        const iconBusiness = new L.Icon({
          iconUrl: "https://cdn2.iconfinder.com/data/icons/national-and-politican-pointers-of-countries/154/country-pointer-geo-location-japan-512.png",
          iconSize: new L.Point(35, 35)
        });
    
        return (
            selectedPosition ? 
                <Marker           
                    key={selectedPosition[0]}
                    position={selectedPosition}
                    interactive={false} 
                    icon={iconBusiness}
                />
            : null
        )   
    };

    const searchIcon = L.icon({
        iconUrl: "https://cdn2.iconfinder.com/data/icons/national-and-politican-pointers-of-countries/154/country-pointer-geo-location-japan-512.png",
        iconSize: [25, 25],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
    });

    const setWenReady = (map) => {
        map.target.on("click", function (e) {
            const {lat, lng} = e.latlng;
            setSelectedPosition([lat, lng]);
            localStorage.setItem("lat", lat);
            localStorage.setItem("lng", lng); 
        });
    };

    return (
        <div style={{height: 250,width: "95%", border: "2px dotted #009286"}}>
            <div className="leaflet-container">
                <Map 
                    style={{height: "100%"}}
                    center={selectedPosition || initialPosition} 
                    zoom={zoom}
                    scrollWheelZoom={true}
                    zoomControl={false}
                    fullscreenControl={true}
                    whenReady={setWenReady}
                >
                    <Markers />
                    <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Search 
                        position="topleft" 
                        showMarker={true}
                        markerIcon={searchIcon}
                        showPopup={false}
                        inputPlaceholder="جستجو..."
                    />
                </Map>
            </div>
        </div>
    );
};
export default _Map;